/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 17H18M12 12L18 12M12 7H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 7L7 8L9 6M6 12L7 13L9 11M6 17L7 18L9 16M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M12 17L18 17M12 12L18 12M12 7H18M6 7L7 8L9 6M6 12L7 13L9 11M6 17L7 18L9 16M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25L14.75 1.25C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27434 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25L22.75 14.75L22.75 14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75L9.25 22.75C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75L1.25 9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27434 3.98005 1.79497ZM9.53035 6.5303C9.82325 6.23741 9.82325 5.76254 9.53035 5.46965C9.23746 5.17675 8.76259 5.17675 8.46969 5.46964L7.00002 6.93931L6.53035 6.46964C6.23746 6.17675 5.76259 6.17675 5.46969 6.46964C5.1768 6.76254 5.1768 7.23741 5.46969 7.53031L6.46969 8.53031C6.61035 8.67096 6.80111 8.74998 7.00002 8.74998C7.19894 8.74998 7.3897 8.67096 7.53035 8.53031L9.53035 6.5303ZM12 6.24998C11.5858 6.24998 11.25 6.58576 11.25 6.99998C11.25 7.41419 11.5858 7.74998 12 7.74998L18 7.74998C18.4142 7.74998 18.75 7.41419 18.75 6.99998C18.75 6.58576 18.4142 6.24998 18 6.24998L12 6.24998ZM9.53035 11.5303C9.82325 11.2374 9.82325 10.7625 9.53035 10.4696C9.23746 10.1768 8.76259 10.1768 8.46969 10.4696L7.00002 11.9393L6.53035 11.4696C6.23746 11.1768 5.76259 11.1768 5.46969 11.4696C5.1768 11.7625 5.1768 12.2374 5.46969 12.5303L6.46969 13.5303C6.76259 13.8232 7.23746 13.8232 7.53035 13.5303L9.53035 11.5303ZM18 11.25L12 11.25C11.5858 11.25 11.25 11.5858 11.25 12C11.25 12.4142 11.5858 12.75 12 12.75L18 12.75C18.4142 12.75 18.75 12.4142 18.75 12C18.75 11.5858 18.4142 11.25 18 11.25ZM9.53035 16.5303C9.82325 16.2374 9.82325 15.7625 9.53035 15.4696C9.23746 15.1768 8.76259 15.1768 8.46969 15.4696L7.00002 16.9393L6.53035 16.4696C6.23746 16.1768 5.76259 16.1768 5.46969 16.4696C5.1768 16.7625 5.1768 17.2374 5.46969 17.5303L6.46969 18.5303C6.76259 18.8232 7.23746 18.8232 7.53035 18.5303L9.53035 16.5303ZM12 17.75L18 17.75C18.4142 17.75 18.75 17.4142 18.75 17C18.75 16.5858 18.4142 16.25 18 16.25L12 16.25C11.5858 16.25 11.25 16.5858 11.25 17C11.25 17.4142 11.5858 17.75 12 17.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15V15V14.5M12 17L18 17M12 12L18 12M12 7H18M6 7L7 8L9 6M6 12L7 13L9 11M6 17L7 18L9 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 17L18 17M12 12L18 12M12 7H18M6 7L7 8L9 6M6 12L7 13L9 11M6 17L7 18L9 16M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.53033 5.46967C9.82322 5.76256 9.82322 6.23744 9.53033 6.53033L7.53033 8.53033C7.38968 8.67098 7.19891 8.75 7 8.75C6.80109 8.75 6.61032 8.67098 6.46967 8.53033L5.46967 7.53033C5.17678 7.23744 5.17678 6.76256 5.46967 6.46967C5.76256 6.17678 6.23744 6.17678 6.53033 6.46967L7 6.93934L8.46967 5.46967C8.76256 5.17678 9.23744 5.17678 9.53033 5.46967ZM11.25 7C11.25 6.58579 11.5858 6.25 12 6.25L18 6.25C18.4142 6.25 18.75 6.58579 18.75 7C18.75 7.41421 18.4142 7.75 18 7.75L12 7.75C11.5858 7.75 11.25 7.41421 11.25 7ZM9.53033 10.4697C9.82322 10.7626 9.82322 11.2374 9.53033 11.5303L7.53033 13.5303C7.23744 13.8232 6.76256 13.8232 6.46967 13.5303L5.46967 12.5303C5.17678 12.2374 5.17678 11.7626 5.46967 11.4697C5.76256 11.1768 6.23744 11.1768 6.53033 11.4697L7 11.9393L8.46967 10.4697C8.76256 10.1768 9.23744 10.1768 9.53033 10.4697ZM11.25 12C11.25 11.5858 11.5858 11.25 12 11.25L18 11.25C18.4142 11.25 18.75 11.5858 18.75 12C18.75 12.4142 18.4142 12.75 18 12.75L12 12.75C11.5858 12.75 11.25 12.4142 11.25 12ZM9.53033 15.4697C9.82322 15.7626 9.82322 16.2374 9.53033 16.5303L7.53033 18.5303C7.23744 18.8232 6.76256 18.8232 6.46967 18.5303L5.46967 17.5303C5.17678 17.2374 5.17678 16.7626 5.46967 16.4697C5.76256 16.1768 6.23744 16.1768 6.53033 16.4697L7 16.9393L8.46967 15.4697C8.76256 15.1768 9.23744 15.1768 9.53033 15.4697ZM18 17.75L12 17.75C11.5858 17.75 11.25 17.4142 11.25 17C11.25 16.5858 11.5858 16.25 12 16.25L18 16.25C18.4142 16.25 18.75 16.5858 18.75 17C18.75 17.4142 18.4142 17.75 18 17.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
